import type { Control, FieldValues, Path } from 'react-hook-form'
import { IContentType } from '~/@api/generated-api-types-user/Api'
import { useAppDialogsStore } from '~/@biz_app-dialogs/appDialogsStore'
import { Text } from '~/@mid_ui/typography/Text'
import { Button } from '~/shadcn/ui/button/button'
import { FieldError, FieldLabel } from '~/shadcn/ui/field'
import { Checkbox } from '~/shadcn/ui/form/checkbox'
import { FormField, FormItem } from '~/shadcn/ui/form/form'

type Props<TFieldValues extends FieldValues = FieldValues> = {
  control: Control<TFieldValues>
  isRequesting: boolean
}

export function GdprCheckBoxFields<
  TFieldValues extends FieldValues = FieldValues,
>({ control, isRequesting }: Props<TFieldValues>) {
  const { setShowContentDialog } = useAppDialogsStore()
  return (
    <>
      <FormField
        control={control}
        name={'gdpr' as Path<TFieldValues>}
        render={({ fieldState, field }) => (
          <FormItem className="gap-1">
            <FieldLabel className="flex flex-row items-center gap-2 cursor-pointer">
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                disabled={isRequesting}
              />
              <Text className="text-sm font-medium leading-normal">
                Súhlasím so spracovaním{' '}
                <Button
                  type="button"
                  size="xs"
                  variant="link"
                  className="p-0 font-normal text-accent"
                  onClick={() =>
                    setShowContentDialog(IContentType.DialogPrivacyGdpr)
                  }>
                  osobných údajov
                </Button>
              </Text>
            </FieldLabel>
            {fieldState.error && (
              <FieldError>{fieldState.error.message}</FieldError>
            )}
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name={'marketing' as Path<TFieldValues>}
        render={({ field }) => (
          <FormItem className="gap-1">
            <FieldLabel className="flex flex-row items-center gap-2 cursor-pointer">
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                disabled={isRequesting}
              />
              <Text className="text-sm font-medium leading-normal">
                Súhlasím so zasielaním{' '}
                <Button
                  type="button"
                  size="xs"
                  variant="link"
                  className="p-0 font-normal text-accent"
                  onClick={() =>
                    setShowContentDialog(IContentType.DialogPrivacyMarketing)
                  }>
                  noviniek
                </Button>
              </Text>
            </FieldLabel>
          </FormItem>
        )}
      />
    </>
  )
}
